document.addEventListener('DOMContentLoaded', () => {
	const e = document.querySelectorAll('.frm-custom');
	e.forEach((e) => {
		const t = e.querySelectorAll('input,select,textarea'),
			q = new Set([...t].filter((e) => e.required)),
			r = (e) => e.closest('.frm-field'),
			n = (e, t = {}) => String(e || '').replace(/\{(\w+)\}/g, (e, r) => (void 0 !== t[r] ? String(t[r]) : e)),
			i = (e, t, r, i = {}) => n(e.getAttribute(`data-error-${t}`)?.trim() || e.getAttribute('data-error')?.trim() || r, { value: 'file' === e.type ? '' : e.value, name: e.name || '', id: e.id || '', min: e.getAttribute('min') || '', max: e.getAttribute('max') || '', minlength: e.minLength >= 0 ? e.minLength : '', maxlength: e.maxLength >= 0 ? e.maxLength : '', pattern: e.getAttribute('pattern') || '', ...i }),
			a = (e, t, n = 'Invalid value.', a = {}) => {
				const l = r(e);
				if (!l) return;
				(e.classList.add('is-error'), e.classList.remove('is-valid'));
				let s = l.querySelector('.frm-error');
				(s || ((s = document.createElement('span')), (s.className = 'frm-error'), l.appendChild(s)), (s.textContent = i(e, t, n, a)));
			},
			l = (e) => {
				const t = r(e);
				if (!t) return;
				e.classList.remove('is-error');
				const n = t.querySelector('.frm-error');
				n && n.remove();
			},
			s = (e) => {
				(l(e), e.classList.add('is-valid'));
			},
			o = (t) => ('file' === t.type ? !t.files || !t.files.length : 'checkbox' === t.type ? !t.checked : 'radio' === t.type ? (t.name ? !e.querySelector(`input[type="radio"][name="${CSS.escape(t.name)}"]:checked`) : !t.checked) : !String(t.value).trim()),
			d = (e, t) => !t.length || t.some((t) => ((t = t.trim()), t && (t.startsWith('.') ? e.name.toLowerCase().endsWith(t.toLowerCase()) : t.endsWith('/*') ? e.type.startsWith(t.slice(0, -1)) : e.type === t))),
			u = (e) => {
				const t = Array.from(e.files || []);
				if (!t.length) return q.has(e) ? (a(e, 'required', 'This field is required.'), !1) : (l(e), e.classList.remove('is-valid'), !0);
				const r = (e.getAttribute('accept') || '')
						.split(',')
						.map((e) => e.trim())
						.filter(Boolean),
					n = +e.dataset.maxSize || 0,
					i = 1048576 * n;
				for (const l of t) {
					if (!d(l, r)) return (a(e, 'format', `"${l.name}" has an unsupported file format.`, { filename: l.name, filetype: l.type, size: l.size }), !1);
					if (n > 0 && l.size > i) return (a(e, 'max-size', `"${l.name}" must be smaller than ${n}MB.`, { filename: l.name, filetype: l.type, max: n, size: l.size }), !1);
				}
				return (s(e), !0);
			},
			c = (e) => {
				if ((l(e), 'file' === e.type)) return u(e);
				if (q.has(e) && o(e)) return (a(e, 'required', 'This field is required.'), !1);
				if (!q.has(e) && o(e)) return (e.classList.remove('is-error', 'is-valid'), !0);
				if ('checkbox' === e.type || 'radio' === e.type) return (s(e), !0);
				const t = String(e.value).trim();
				return e.minLength >= 0 && t.length < e.minLength ? (a(e, 'minlength', `Please enter at least ${e.minLength} characters.`), !1) : e.maxLength >= 0 && t.length > e.maxLength ? (a(e, 'maxlength', `Please enter no more than ${e.maxLength} characters.`), !1) : e.hasAttribute('min') && e.validity.rangeUnderflow ? (a(e, 'min', `Value must be at least ${e.getAttribute('min')}.`), !1) : e.hasAttribute('max') && e.validity.rangeOverflow ? (a(e, 'max', `Value must not exceed ${e.getAttribute('max')}.`), !1) : e.validity?.stepMismatch ? (a(e, 'step', 'Please enter a valid value.'), !1) : e.validity?.patternMismatch ? (a(e, 'pattern', 'Please enter a valid value.'), !1) : e.validity?.typeMismatch ? (a(e, 'type', 'Please enter a valid value.'), !1) : e.validity?.badInput ? (a(e, 'invalid', 'Please enter a valid value.'), !1) : (s(e), !0);
			};

		(t.forEach((e) => {
			'file' === e.type || 'checkbox' === e.type || 'radio' === e.type || 'SELECT' === e.tagName
				? e.addEventListener('change', function () {
						c(this);
					})
				: (e.addEventListener('blur', function () {
						c(this);
					}),
					e.addEventListener('input', function () {
						c(this);
					}));
		}),
			e.addEventListener('submit', (r) => {
				r.preventDefault();
				let n = !0,
					i = null;
				(t.forEach((e) => {
					c(e) || ((n = !1), i || (i = e));
				}),
					n ? f(new FormData(e)) : i && (i.focus(), i.scrollIntoView({ behavior: 'smooth', block: 'center' })));
			}));

		async function f(n) {
			const i = e.querySelector('.frm-submit'),
				a = e.dataset.endpoint || '/tools/crm/nubest-form',
				l = i?.textContent;
			let s = e.querySelector('.frm-message');
			try {
				(s || ((s = document.createElement('div')), (s.className = 'frm-message'), i ? i.insertAdjacentElement('afterend', s) : e.appendChild(s)), (s.textContent = ''), s.classList.remove('error'), (s.hidden = !0), i && ((i.disabled = !0), (i.textContent = 'Submitting...')));
				const r = await fetch(a, { method: 'POST', body: n }),
					o = await r.json();
				if (!r.ok) throw Error(o?.message || 'Submit failed');
				1 === Number(o.status)
					? ((s.textContent = o.message || 'Your application has been submitted successfully.'), s.classList.remove('error'), (s.hidden = !1), e.reset(), t.forEach((e) => e.classList.remove('is-valid', 'is-error')), e.querySelectorAll('.frm-error').forEach((e) => e.remove()))
					: ((s.textContent = o.message || 'There was an error submitting your application.'), s.classList.add('error'), (s.hidden = !1));
				s.scrollIntoView({ behavior: 'smooth', block: 'center' });
			} catch (t) {
				(console.error(t), (s.textContent = t.message || 'There was an error submitting your application. Please try again.'), s.classList.add('error'), (s.hidden = !1), s.scrollIntoView({ behavior: 'smooth', block: 'center' }));
			} finally {
				i && ((i.disabled = !1), (i.textContent = l));
			}
		}
	});
});